module.exports = __webpack_public_path__ + "static/33-game-robot-557b426752a2929bbf57e95edd4845bf.png";